import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

const MapModal = ({ show, onClose, onSelect, fetchData, address, coordinates, setShowMapModal }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  const [selectedAddress, setSelectedAddress] = useState();
  const [selectedCoordinates, setSelectedCoordinates] = useState();

  useEffect(() => {
    if (show) {
      initMap();
    }
  }, [show]);

  const initMap = () => {
    const map = new window.google.maps.Map(document.getElementById("map"), {
      center: coordinates || { lat: -34.397, lng: 150.644 }, 
      zoom: 8,
    });

    map.addListener("click", (e) => {
      const latlng = e.latLng;
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK" && results[0]) {
          setSelectedAddress(results[0].formatted_address);
          setSelectedCoordinates({
            lat: latlng.lat(),
            lng: latlng.lng(),
          });

          addMarker(map, { lat: latlng.lat(), lng: latlng.lng() });
        }
      });
    });

    mapRef.current = map;

    if (address && coordinates) {
      addMarker(map, coordinates);
    }
  };

  const addMarker = (map, position) => {
    if (markerRef.current) {
      markerRef.current.setMap(null); 
    }
    markerRef.current = new window.google.maps.Marker({
      position,
      map,
      icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
    });
  };

  useEffect(() => {
    if (show && mapRef.current && coordinates) {
      mapRef.current.setCenter(coordinates); 
      addMarker(mapRef.current, coordinates);
    }
  }, [show, coordinates]);

  useEffect(()=>{
    if (address === "") {
      setSelectedAddress();
      setSelectedCoordinates({});
      fetchData()
    }
  },[address]);

  const handleSubmit = () => {
    if (address && coordinates) {
      onSelect(selectedAddress ? selectedAddress : address, selectedCoordinates ? selectedCoordinates: coordinates);
      fetchData(); 
    }
    setShowMapModal(false);
  };

  return (
    <>
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select Location</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div id="map" style={{ height: "550px", width: "100%" }}></div>
      <script
        src={`https://maps.googleapis.com/maps/api/js?key=AIzaSyA4vgo78Hc2QMHjL33_bM3DNpd4e-oCb8E`}
        async
        defer
      ></script>
    </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
   
      <button onClick={onClose} className="btn btn-secondary me-2">
        Cancel
      </button>
 
      <button onClick={handleSubmit} className="btn btn-primary">
        Submit
      </button>
    </Modal.Footer>
    </Modal>
  </>
  
  );
};

export default MapModal;
